import { Injectable } from '@angular/core';
import { Router, NavigationStart, Event } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { setActiveAssayTab } from './actions';
/** Injectable service to listen for navigation events and manage the active assay tab state */
@Injectable({ providedIn: 'root' })
export class AssayNavigationWatcherService {
    /**
     * 
     * @param router Router
     * @param store Injecting store for state management
     */
    constructor(private router: Router, private store: Store) {
        this.router.events.pipe(
            filter((event: Event): event is NavigationStart => event instanceof NavigationStart),
            filter(event => this.isLeavingAssay(event.url))
        ).subscribe(() => {
            this.store.dispatch(setActiveAssayTab({
                activeAssayTab: null
            }));
        });
    }
    /** Helper method to check if the URL is leaving an "assay" page or related section */
    private isLeavingAssay(url: string): boolean {
        return !url.includes('/assay') && !url.includes('print');
    }
}
